// extracted by mini-css-extract-plugin
module.exports = {"link":"InsightPostCTALink__link__j3Hdf"};